import React from 'react'
import { BUS_RESULT, BusResultCard } from '../BusResults'
import SeatBookingPanel from './SeatBookingPanel'

// Standalone version of the seat-selection view — kept for direct linking,
// though the normal flow now expands SeatBookingPanel inline under a bus
// result card's "VIEW SEATS" button (see BusResults.jsx) instead of
// navigating here.
const BusSeatSelection = () => {
    return (
        <>
            <section className='commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <BusResultCard item={BUS_RESULT} />
                            <SeatBookingPanel initialTab='selectSeat' />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BusSeatSelection
